/* eslint-disable react/prop-types */
import images from "../../assets/images/assets";

const SectionImage02 = ({ image }) => {
  return (
    <div className="w-full h-[95%] lg:w-[480px] lg:h-[680px] mt-4 border border-prime-red  p-4 rounded-t-full relative z-[9999]">
      <img
        src={images.star1}
        alt="decorative"
        className="absolute -top-3 md:left-54 left-35"
      />
      <div
        style={{ backgroundImage: `url(${image})` }}
        className="w-full h-full bg-zinc-300 rounded-t-full bg-cover saturate-120 bg-center"
      ></div>
    </div>
  );
};

export default SectionImage02;
